import { useEffect, useRef } from "react"
import { AiMessageBubble, AiStreamingBubble } from "./ai-message-bubble"
import { useAiStore } from "@/stores/ai-store"
import type { AiMessage } from "@/lib/ai-types"

interface AiChatMessagesProps {
  messages: AiMessage[]
}

export function AiChatMessages({ messages }: AiChatMessagesProps) {
  const { isStreaming, streamingContent, activeToolCalls } = useAiStore()
  const bottomRef = useRef<HTMLDivElement>(null)

  // Auto-scroll to bottom on new messages or streaming
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" })
  }, [messages.length, streamingContent, activeToolCalls.size])

  return (
    <div className="flex flex-1 flex-col gap-3 overflow-y-auto px-4 py-4">
      {messages.map((msg) => (
        <AiMessageBubble key={msg.id} message={msg} />
      ))}

      {isStreaming && (
        <AiStreamingBubble content={streamingContent} toolCalls={activeToolCalls} />
      )}

      <div ref={bottomRef} />
    </div>
  )
}
